import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import axios from 'axios';

import { useLanguage } from '../contexts/LanguageContext';
import { useResto } from '../contexts/RestoContext';
import { setFlashMessage } from '../contexts/WebsiteContext';
import config from '../config/config';

const MenusLight = () => {
  const { t } = useTranslation();
  const { activeLanguage } = useLanguage();
  const { restoData } = useResto();
  const { apiUrl } = config;
  const apiPath = `${apiUrl}menu`;

  const [menusByLanguage, setMenusByLanguage] = useState({});

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    try {
      const response = await axios.get(`${apiPath}?website=${restoData.website}`);
      const menus = response.data;
      const menusByLang = {};
      // Group menus by language
      menus.forEach(menu => {
        if (!menusByLang[menu.language]) {
          menusByLang[menu.language] = [];
        }
        menusByLang[menu.language].push(menu);
      });
      setMenusByLanguage(menusByLang);
    } catch (error) {
      setFlashMessage(t('ERROR_MESSAGE'), 'error');
    }
  };


  return (
    <div className="d-flex justify-content-center background-main-color-60" style={{ color: 'rgb(255,255,255)', padding: '5px 0'}}>
        {menusByLanguage[activeLanguage] && menusByLanguage[activeLanguage].map(menu => (
        <a key={menu.id} href={`${config.documentsUrl}menus/${menu.filename}`} target="_blank" rel="noopener noreferrer" style={{margin: '0 5px'}}>
            <Button variant="primary">
            {menu.label}
            </Button>
        </a>
        ))}
    </div>
  );
}

export default MenusLight;
